/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';
import { FC, useEffect, useState } from 'react';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
const DotLottieReact = dynamic(() => import('@lottiefiles/dotlottie-react').then(mod => mod.DotLottieReact), {
  ssr: false,
});

interface LottiePlayerProps {
  src?: string;
  className?: string;
  loop?: boolean;
  autoplay?: boolean;
  type?: 'json' | 'lottie';
}

const LottiePlayer: FC<LottiePlayerProps> = ({ src, className, loop = true, autoplay = true, type = 'json' }) => {
  const [data, setData] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!src) {
      setIsLoading(false);

      return;
    }

    let cancelled = false;
    setIsLoading(true);

    if (type === 'lottie') {
      setData(src);
      setIsLoading(false);

      return;
    }

    (async () => {
      try {
        const res = await fetch(src);

        if (cancelled) {
          return;
        }

        if (!res.ok) {
          setIsLoading(false);

          return;
        }

        const json = await res.json();

        if (!cancelled) {
          setData(json);
          setIsLoading(false);
        }
      } catch {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [src, type]);

  if (isLoading || !data) {
    return <div className={className} />;
  }

  if (type === 'lottie') {
    return <DotLottieReact src={data} loop={loop} autoplay={autoplay} className={className} />;
  }

  return <Lottie animationData={data} loop={loop} autoplay={autoplay} className={className} />;
};

export default LottiePlayer;
